import React from "react";
import "./Card.scss";
import { Link } from "react-router-dom";
import CityModal from "../../components/CityModal/CityModal";

const Card = ({price,title,url,click}) => {
  
  return (
    <div
    id={title}
      className="card-container"
      onClick={click}
    >
      <img src={url} alt="" loading="lazy" />
      {price&&<span className="sticker">от {price} &#36;</span>}

      <h2 className={price || price===""?'text-h2':''}>{title}</h2>
    </div>
  );
};

export default Card;
